import "./App.css";
import { GameCard } from "./modules/GameCard";

function App() {
  return (
    <div className="App">
      <GameCard
        url="https://store.steampowered.com/app/1245620/ELDEN_RING/"
        title="Elden Ring"
        year="Feb 25, 2022"
        image="https://images.igdb.com/igdb/image/upload/t_cover_big/co4jni.png"
        rating="95/100"
        timeToBeat="57.5 hours"
      />
      <GameCard
        url="https://opencritic.com/game/14343/the-legend-of-zelda-tears-of-the-kingdom"
        title="The Legend of Zelda: Tears of the Kingdom"
        year="May 12, 2023"
        image="https://images.igdb.com/igdb/image/upload/t_cover_big/co5vmg.png"
        rating="96/100"
        timeToBeat="59 hours"
      />
      <GameCard
        url="https://www.igdb.com/games/sea-of-stars"
        title="Sea of Stars"
        year="Aug 28, 2023"
        image="https://images.igdb.com/igdb/image/upload/t_cover_big/co215b.png"
        rating="89/100"
        timeToBeat="27 hours"
      />
    </div>
  );
}

export default App;
